/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "adminApi",
            "endpoint": "https://2qskkl7hr2.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:d1c44316-4486-4291-9321-f04a341272a4",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_sv5tnzvSn",
    "aws_user_pools_web_client_id": "24cupnhunpotckbkcgl87rnh5u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "utilif_live_inventory",
            "region": "eu-central-1"
        },
        {
            "tableName": "utilif_live_product_mapping",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "utilif-v3-data-live-private-temp",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
